/**
 * Frontend Logger
 * 
 * Einfacher Logger für Development (ersetzt console.log)
 */

const isDevelopment = import.meta.env.DEV;

class Logger {
  private prefix = '[KingofAnts]';

  info(message: string, ...args: any[]): void {
    if (isDevelopment) {
      console.log(`${this.prefix} [INFO]`, message, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (isDevelopment) {
      console.warn(`${this.prefix} [WARN]`, message, ...args);
    }
  }

  error(message: string, ...args: any[]): void {
    console.error(`${this.prefix} [ERROR]`, message, ...args);
  }

  debug(message: string, ...args: any[]): void {
    if (isDevelopment) {
      console.debug(`${this.prefix} [DEBUG]`, message, ...args);
    }
  }
}

const logger = new Logger();
export default logger;
